import { HelpCircle } from "lucide-react";

export default function FAQSection() {
  const faqs = [
    {
      question: "Preciso de ERP?",
      answer: "Não.",
    },
    {
      question: "Preciso de equipe de BI?",
      answer: "Não.",
    },
    {
      question: "É complexo?",
      answer: "Não. A profundidade está no motor, não na interface.",
    },
    {
      question: "Funciona offline?",
      answer: "Sim.",
    },
    {
      question: "Meus dados ficam armazenados externamente?",
      answer: "Não.",
    },
  ];

  return (
    <section
      id="faq"
      className="relative py-16 md:py-32 bg-[#0F1115]"
      data-testid="faq-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Dúvidas
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Perguntas <span className="text-[#F59E0B]">Frequentes</span>
          </h2>
        </div>

        {/* FAQ List - Static */}
        <div className="max-w-2xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-6"
                data-testid={`faq-item-${index}`}
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                    <HelpCircle className="h-4 w-4 text-[#F59E0B]" />
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-[#E5E7EB] mb-2">
                      {faq.question}
                    </h3>
                    <p className="text-[#9CA3AF]">{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
